import { useState } from 'react';
import { trU } from '../../lib/i18n';
import { C } from '../../theme/palette';
import { corrigerFr } from '../../lib/correcteur';

export const _inp = {
  width: '100%',
  border: '1px solid ' + C.border,
  borderRadius: 10,
  padding: '11px 12px',
  fontSize: 12,
  color: C.ink,
  background: C.white,
  fontWeight: 600,
  outline: 'none',
};

export const NumInput = ({ value, onChange, placeholder, style, disabled }) => {
  const [buf, setBuf] = useState(null);
  const shown =
    buf !== null
      ? buf
      : value === 0 ||
          value === '' ||
          value === undefined ||
          value === null ||
          (typeof value === 'number' && isNaN(value))
        ? ''
        : String(value);
  return (
    <input
      type="text"
      inputMode="decimal"
      placeholder={placeholder}
      value={shown}
      disabled={disabled}
      onChange={(e) => {
        let v = (e.target.value || '').replace(',', '.');
        if (!/^\d*\.?\d*$/.test(v)) return;
        setBuf(v);
        const out = v === '' || v === '.' ? '' : v;
        if (onChange) onChange({ target: { value: out } });
      }}
      onBlur={() => setBuf(null)}
      style={style || _inp}
    />
  );
};

/**
 * « ✨ Corriger » sous une zone de texte : correcteur local (`lib/correcteur`),
 * sans appel réseau. Rend la correction par le même `onChange` que la saisie.
 * `avant` : un outil posé à sa gauche, comme la couleur d'un message.
 */
export const BoutonCorriger = ({ value, onChange, avant }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: 6,
      marginTop: 3,
    }}
  >
    {avant}
    <button
      type="button"
      onClick={() => onChange && onChange({ target: { value: corrigerFr(value || '') } })}
      style={{
        fontSize: 9.5,
        fontWeight: 800,
        color: C.teal,
        cursor: 'pointer',
        background: C.tealL,
        border: 'none',
        padding: '4px 10px',
        borderRadius: 7,
      }}
    >
      ✨ Corriger
    </button>
  </div>
);

export const Inp = ({
  label,
  value,
  onChange,
  type = 'text',
  placeholder,
  rows,
  children,
  list,
  onBlur,
  outil,
  styleTexte,
}) => (
  <div style={{ marginBottom: 10 }}>
    {label && (
      <div
        style={{
          fontSize: 9,
          fontWeight: 700,
          color: C.muted,
          marginBottom: 3,
          textTransform: 'uppercase',
          letterSpacing: 0.4,
        }}
      >
        {trU(label)}
      </div>
    )}
    {children ||
      (rows ? (
        <>
          <textarea
            rows={rows}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            style={{ ..._inp, resize: 'vertical', fontFamily: 'inherit', ...styleTexte }}
          />
          <BoutonCorriger value={value} onChange={onChange} avant={outil} />
        </>
      ) : type === 'number' ? (
        <NumInput value={value} onChange={onChange} placeholder={placeholder} />
      ) : (
        <input
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          // Les propositions d'une liste (« datalist »), sans fermer la saisie libre.
          list={list}
          style={_inp}
        />
      ))}
  </div>
);

export const inpFS = {
  width: '100%',
  border: '1px solid ' + C.border,
  borderRadius: 9,
  padding: '10px 11px',
  fontSize: 11,
  marginBottom: 10,
};
